import useUser from "../../../../hooks/user";
import { ReactNode, useEffect, useState } from "react";
import { LocalStorageKeys, Voice } from "../../../../types";
import VoiceAvatar from "./VoiceAvatar";
import { useSelectedVoice } from "../../../../hooks/voice";
import RadixDialog from "../RadixDialog";
import classNames from "./VoiceOptionsDialog.module.css";

type VoiceOptionsDialogProps = {
  locale: string;
  selectedVoiceId?: string;
  onConfirm?: (voiceId: string) => void;
  setOpen?: (open: boolean) => void;
  basic?: boolean;
};

export const VoiceOptions = (props: VoiceOptionsDialogProps) => {
  const [user] = useUser();

  const initialVoice = useSelectedVoice(
    user.metadata.selectedLanguage,
    localStorage.getItem(LocalStorageKeys.VOICE_AVATAR) || props.selectedVoiceId
  );
  const [selectedVoice, setSelectedVoice] = useState<Voice | undefined>(
    initialVoice
  );

  // Save changes to local storage
  useEffect(() => {
    if (selectedVoice?.id) {
      localStorage.setItem(LocalStorageKeys.VOICE_AVATAR, selectedVoice.id);
    }
  }, [selectedVoice?.id]);

  return (
    <VoiceAvatar
      basic={props.basic}
      selectedVoice={selectedVoice}
      onSelectVoice={setSelectedVoice}
    />
  );
};

const VoiceOptionsDialog = (
  props: VoiceOptionsDialogProps & { trigger: ReactNode }
) => {
  const [open, setOpen] = useState(false);
  return (
    <RadixDialog
      title={"Voice avatar options"}
      trigger={props.trigger}
      content={<VoiceOptions {...props} setOpen={setOpen} />}
      open={open}
      onOpenChange={setOpen}
      className={classNames.VoiceOptionsDialog}
    />
  );
};

export default VoiceOptionsDialog;
